import { render, staticRenderFns } from "./SPIFSidebar.vue?vue&type=template&id=0a84cf54"
import script from "./SPIFSidebar.vue?vue&type=script&lang=js"
export * from "./SPIFSidebar.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports